import { render, staticRenderFns } from "./CreateIncidentModal.vue?vue&type=template&id=132d5711&scoped=true"
import script from "./CreateIncidentModal.vue?vue&type=script&lang=js"
export * from "./CreateIncidentModal.vue?vue&type=script&lang=js"
import style0 from "./CreateIncidentModal.vue?vue&type=style&index=0&id=132d5711&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132d5711",
  null
  
)

export default component.exports